// This file is generated.
export var version = '2.0.0';
//# sourceMappingURL=version.js.map